import React, { forwardRef } from "react";
import styles from "./inputComponent.module.scss";
import EyeOff from "../../../assets/images/pages/login/eyeoff.png";
import EyeOn from "../../../assets/images/pages/login/oneye.svg";
import DatePicker from "../datePicker/DatePicker";

interface InputComponentProps {
  label?: string;
  type: string;
  name: string;
  placeholder: string | undefined;
  value?: string;
  onChange?: (e: any) => void;
  isPassword?: boolean;
  isShowPassword?: boolean;
  toggleShowPassword?: () => void;
  className?: string;
  error?: string;
  isTimePicker?: boolean;
  minTime?: Date;
  maxTime?: Date;
  disabled?: boolean;
  readOnly?: boolean;
  min?: string;
  maxLength?: number;
  max?: string;
  autoComplete?: boolean;
}

const InputComponent = forwardRef<HTMLInputElement, InputComponentProps>(
  (
    {
      label,
      type,
      name,
      placeholder,
      maxLength,
      value = "",
      onChange,
      isPassword = false,
      isShowPassword = false,
      toggleShowPassword,
      className,
      error,
      disabled,
      readOnly,
      min,
      maxTime,
      minTime,
      max,
      autoComplete,
      isTimePicker,
    },
    ref,
  ) => {
    const formatDateToLocalISO = (date: Date, includeTime = false) => {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");

      if (!includeTime) return `${year}-${month}-${day}`;

      const hours = String(date.getHours()).padStart(2, "0");
      const minutes = String(date.getMinutes()).padStart(2, "0");
      const seconds = String(date.getSeconds()).padStart(2, "0");

      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    };

    const handleDateChange = (date: Date | null) => {
      const dateString = date ? formatDateToLocalISO(date, isTimePicker) : "";
      onChange?.({
        target: {
          name: name,
          value: dateString,
        },
      });
    };

    return (
      <div className={styles.input_container}>
        {label && <p className={styles.inputText}>{label}</p>}

        <div className={styles.input_control}>
          {type === "date" ? (
            <div className={styles.datePickerWrapper}>
              <DatePicker
                isTimePicker={isTimePicker}
                maxTime={maxTime}
                minTime={minTime}
                value={value}
                onChange={handleDateChange}
                placeholder={placeholder}
                min={min}
                max={max}
                readOnly={readOnly}
                ref={ref}
              />
            </div>
          ) : (
            <>
              <input
                type={isPassword && isShowPassword ? "text" : type}
                name={name}
                placeholder={placeholder}
                value={value}
                onChange={onChange}
                className={`${className} ${styles.input}`}
                disabled={disabled}
                readOnly={readOnly}
                min={min}
                max={max}
                autoComplete={autoComplete ? "new-password" : ""}
                ref={ref}
                maxLength={maxLength}
              />
              {isPassword && toggleShowPassword && (
                <div
                  onClick={toggleShowPassword}
                  className={styles.passwordIcon}
                >
                  <img src={isShowPassword ? EyeOff : EyeOn} alt="EyeIcon" />
                </div>
              )}
            </>
          )}
        </div>

        {error && <p className={styles.error_message}>{error}</p>}
      </div>
    );
  },
);

export default InputComponent;
